(function(rivets) {
	rivets.formatters["trans"] = function(key, translator) {
		return translator ? translator.trans(key) : key;
	};
})(rivets);
